import React from 'react'
import { FormControl, FormGroup, ControlLabel, HelpBlock  } from 'react-bootstrap';

const FieldGroup = ({ id, label, help, validationState, ...props }) => {
  return (
    <FormGroup controlId={id} validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
      <FormControl.Feedback />
    </FormGroup>
  );
}

export default FieldGroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js